import { render, staticRenderFns } from "./HeaderBig.vue?vue&type=template&id=1d6c97ba&"
import script from "./HeaderBig.vue?vue&type=script&lang=js&"
export * from "./HeaderBig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports